module.exports = __webpack_public_path__ + "static/img/0.590adc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/en/upload/commonality/20251009/0.jpg
// module id = 1Szp
// module chunks = 7